// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterLinks_container__2rYVN","label":"FooterLinks_label__2IQz3","arrow":"FooterLinks_arrow__2AsbW","list":"FooterLinks_list__2d9Vi","item":"FooterLinks_item__8iJo8"};